/**
 * Created by Jerker Nord on 2019-03-22.
 */
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Elastic, TimelineLite} from "gsap";
import {ThorGameMode} from "../gamemode/ThorGameMode";
import {ThorGameShaker} from "../gameshake/ThorGameShaker";
import {ThorRespinNudgeReelController} from "../reel/nudgereel/ThorRespinNudgeReelController";
import {ThorFSBonusFeaturePlayingController} from "../reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorParsedGameData} from "../server/data/ThorParsedGameData";
import {ThorGameConfig} from "../ThorGameConfig";
import {ThorGameModuleConfig} from "../ThorGameModuleConfig";
import {ThorSoundConfig} from "../ThorSoundConfig";

export class ThorFSBonusFeatureController extends BeforeSpinStopPresentationController {

    private _nudgeFeatureRewarded:string;
    private _payoutMultiplierAfter:number;
    private _currentMode:string;
    private _nextMode:string;
    private _topSym:string;
    private _animationDuration:number = 6;
    private _FSLeft:number = 0;

    constructor(index:number) {
        super(index, "ThorFSBonusFeatureController");
    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        this._nudgeFeatureRewarded = data.nudgeFeatureRewarded;
        this._payoutMultiplierAfter = data.payoutMultiplierAfter;
        this._FSLeft = data.freespinsLeft;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._topSym = data.reels[4][3];
        if(this._topSym == "B") {
            this._topSym = data.reels[4][2];
        }
        if((data.mode == ThorGameMode.NUDGE_RESPIN_FS && (data.nextMode == ThorGameMode.NUDGE_RESPIN_FS || data.nextMode == ThorGameMode.FREESPIN || data.nextMode == ThorGameMode.NORMAL))) {
            return true;
        }
        return false;//If FS and new feature awarded
    }

    private replaceSymbol():void {
        Reels.getSymbol(4, -1)!.replaceWith(this._topSym, 4);
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        if(this._nextMode !== ThorGameMode.NUDGE_RESPIN_FS) {
            return GameSetting.isFastSpin ? 1 : 1.5;
        } else {
            return this._animationDuration;
        }
    }

    public tryStartPresentation(data:ThorParsedGameData):number {
        if(this.parseFeatureTriggered(data)) {
            this._isPlaying = true;
            this._timeline = new TimelineLite({onComplete : () => this.finish()});
            this.startPresentation(this._timeline);

            return this.getSpinStopDelay(data);
        }
        return 0;
    }

    protected startPresentation(timeline:TimelineLite):void {
        timeline.add([
            () => Reels.getSymbol(4, 0)!.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.3
            }),
            () => Reels.getSymbol(4, 1)!.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.3
            }),
            () => Reels.getSymbol(4, 2)!.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.3
            })
        ]);
        timeline.add(() => this.replaceSymbol());
        timeline.add(() => (<ThorRespinNudgeReelController>Reels.getReel(4)).nudge(1, 1, Elastic.easeIn.config(1, 1), 0));
        timeline.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_NUDGE));
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.START_GAME_SHAKING_REEL_AREA)), "+=1.1");
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.STOP_GAME_SHAKING)), "+=0.4");
        if(this._nudgeFeatureRewarded !== "") {
            timeline.add(() => ThorGameModuleConfig.thorMjolnirtimeView.getMjolnirtimeAnimation().play());
            let tempTL:TimelineLite = this.getFeatureAnimation();
            timeline.add(tempTL);
            timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_STARTED)), "-=" + (tempTL.totalDuration() - 0.2));
        }
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED)));
    }

    private getFeatureAnimation():TimelineLite {
        switch(this._nudgeFeatureRewarded) {
            case ThorParsedGameData.NUDGE_REWARDED_RANDOM_WILDS :
                return ThorGameModuleConfig.thorRandomWildIconView.enableRandomWildIconSelectTL((this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN));

            case ThorParsedGameData.NUDGE_REWARDED_EXTRA_FS_SPINS :
                const timeline:TimelineLite = new TimelineLite();
                timeline.add(ThorGameModuleConfig.thorExtraFSIconView.getFSIconSelectTL((this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN)));
                return timeline;

            case ThorParsedGameData.NUDGE_REWARDED_WILD_REELS_FEATURE :
                return ThorGameModuleConfig.thorReelWildIconView.enableReelWildIconTL((this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN));

            default :
                return ThorGameModuleConfig.thorMultiplierIconView.enableMultiplierIconTL(this._payoutMultiplierAfter, (this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN));
        }
    }

    public abort():void {
        if(this._isPlaying) {
            this._isPlaying = false;
            this._isAborted = true;
            this._timeline.progress(1);
        }
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            (<ThorRespinNudgeReelController>Reels.getReel(4)).abortNudge();
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}